import React from 'react'
import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'

import MaterialSymbol from '../../../components/MaterialSymbol'
import { SEED_MIX_TYPE } from '../types/SeedOrderFormType'
import { Button } from '../../../components/Button'

export const premixName = 'Straight or premixed'
export const customName = 'Customised seed mix'

export const NewSeedTypeButton = ({
  seedType,
  onClick,
}: {
  seedType: SEED_MIX_TYPE
  onClick: () => void
}) => {
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Stack
      spacing={isSm ? 2 : 4}
      alignItems={isSm ? 'flex-start' : 'center'}
      p={isSm ? 3 : 8}
      bgcolor='white'
      borderRadius='10px'
      border='1px solid #EAEFE6'
      width={isSm ? '100%' : 'auto'}
    >
      <Stack alignItems='center' spacing={1} direction={isSm ? 'row' : 'column'}>
        <MaterialSymbol
          sx={{
            fontSize: isSm ? '18px' : '40px',
            color: theme.colors.primary500,
            fontWeight: 'bold',
          }}
        >
          {seedType === SEED_MIX_TYPE.PREMIX ? 'inventory_2' : 'wysiwyg'}
        </MaterialSymbol>
        <Typography variant='body1' fontWeight='700' color={theme.colors.primary500}>
          {seedType === SEED_MIX_TYPE.PREMIX ? premixName : customName}
        </Typography>
      </Stack>
      <Button variant='contained' onClick={onClick}>
        Start order
      </Button>
    </Stack>
  )
}
